import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { UpdateIdCompletedService } from "@/features/user/services/update-id-completed-service";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { EndpointPathNames } from "@/shared/config/endpoint-path";
import { LoginHeader } from "@/shared/components/header/login-header";
import { Footer } from "@/shared/components/footer/footer";
import { useErrorContext } from "@/shared/context/error-context";
import { MoneyLinkException, MoneyLinkWarning } from "@/shared/utils/custom-exception";
import { MailAddressForm } from "@/shared/components/text-box/mail-address-form";

export const UpdateIdCompleted = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token") ?? "";
  const navigate = useNavigate();
  const [newEmailAddress, setNewEmailAddress] = useState("");
  const mailAddressFormId = "update_id_completed_mail_address_form_id";
//  const { isHex32 } = useValidators();
//  useEffect(() => {
//    if (token === "" || !isHex32(token)) {
//      navigate(EndpointPathNames.ERROR, { replace: true });
//    }
//  }, [token]);
//
//  if (token === "" || !isHex32(token)) {
//    return null; // エラー遷移するまで描画しない
//  }
  const { setError } = useErrorContext();
  const updateIdCompletedService = new UpdateIdCompletedService();

  useEffect(() => {
    const load = async () => {
      try {
        const res = await updateIdCompletedService.updateIdCompletedInit({token: token});
        setNewEmailAddress(res.owner_id);
      } catch (error) {
        if (error instanceof MoneyLinkException && error.error.props?.messageBody) {
          const { messageBody } = error.error.props;
          setError(new MoneyLinkWarning({
            title: "エラー",
            message: messageBody
          }));
          navigate(EndpointPathNames.LOGIN);
        } else {
          navigate("/error");
        }
      }
    };
    load();
  }, [token, navigate]);

  return (
    <>
      <LoginHeader content="メールアドレスの再設定" />
      <main>
        <section id="rePass">
          <p>メールアドレスの変更が完了しました。</p>
          <ul className="form">
            <li>
              <MailAddressForm
                key={`${mailAddressFormId}-${newEmailAddress}`}
                className="signUpMail"
                id={mailAddressFormId}
                initialValue={newEmailAddress}
                title="新しいメールアドレス"
                isReadOnly={true}
              />
            </li>
          </ul>
          <div className="notice">
            <p>新しいメールアドレスに更新されました。これまでのメールアドレスはご利用になれませんのでご注意ください。</p>
          </div>
          <nav className="btns">
            <BaseRoundButton
              buttonText="ログインへ"
              onClick={() => {
                navigate(EndpointPathNames.LOGIN)
              }}
              isActive={true}
              className="nav-main"
            />
          </nav>
        </section>
      </main>
      <Footer />
    </>
  );
};
